import React, { useState, useEffect } from "react";

// Services
import { formatterService } from "../services/formatters.service";

function InputComponent(props) {

	const [inputValue, setInputValue] = useState(props.value || "");
	const [loading, setLoading] = useState(false);

	const formatZipCode = (value) => {
		if (value) {
			value = formatterService.onlyNumberValue(value);
			if (value.length <= 5) {
				return value;
			}
			return `${value.substr(0, 5)}-${value.substr(5, 3)}`;
		}
		return value;
	};

	const handleCepChange = async (e) => {
		let formattedCep = formatZipCode(e.target.value);
		if (formattedCep.length === 9) {
			try {
				if (props.defineAddress) {
					const zipCode = formatterService.onlyNumberValue(e.target.value);
					props.defineAddress(zipCode);
				}
			} catch (error) {
				console.error("Erro na busca de cep", error);
			}
		}
		setInputValue(formattedCep);
	};

	const handleNumber = (e) => {
		let value = e.target.value;

		if (props.maxLength) {
			if (value.length <= props.maxLength) {
				setInputValue(formatterService.onlyNumberValue(value));
			}
		}
		else
			setInputValue(formatterService.onlyNumberValue(value));

		props.handleInput({
			target: {
				id: e.target.id,
				value: value
			}
		});
	};

	const handleDocChange = (e) => {
		const value = e.target.value;
		const formattedCpf = formatterService.formatCpf(value);
		setInputValue(formattedCpf);

		props.handleInput({
			target: {
				id: props.id,
				value: formattedCpf
			}
		});
	};

	const handlePhoneChange = (e) => {
		const value = e.target.value;
		const formatted = formatterService.formatPhone(value);
		setInputValue(formatted);

		props.handleInput({
			target: {
				id: props.id,
				value: formatted
			}
		});
	};

	const handleBlur = async (event) => {
		if (props.onBlur) {
			await props.onBlur(event.target.value);
		}
	};

	useEffect(() => {
		setLoading(props.loading);
	}, [props.loading]);

	useEffect(() => {
		setInputValue(props.value || "");
	}, [props.value]);


	const className = `form-control custom-input ${props.customClass ? props.customClass : ""}`
	return (
		<div>
			{props.label ? (<label htmlFor={props.id} className="form-label ">{props.label}</label>) : ("")}

			{loading ? (

				<div className="input-group-append">
					<div className="spinner-border text-success" role="status">
						<span className="visually-hidden"></span>
					</div>
				</div>


			) : (<>

				{props.type?.toLowerCase() === "cep" ? (
					<input type={props.type}
						className={className}
						id={props.id}
						disabled={props.disabled}
						placeholder={props.placeholder}
						value={inputValue}
						onChange={async (e) => handleCepChange(e)}
					/>
				) : ("")}


				{props.type?.toLowerCase() === "cpf" ? (
					<input type="text"
						className={className}
						id={props.id}
						disabled={props.disabled}
						placeholder={props.placeholder}
						value={inputValue}
						maxLength="14"
						onChange={async (e) => handleDocChange(e)}
					/>
				) : ("")}

				{props.type?.toLowerCase() === "text" || props.type?.toLowerCase() === "email" ? (
						<input type={props.type} disabled={props.disabled} className={className} onBlur={handleBlur} value={inputValue} id={props.id} onChange={props.handleInput} placeholder={props.placeholder} />
				) : ("")}


				{props.type?.toLowerCase() === "phone" ? (
					<input type="text"
						className={className}
						id={props.id}
						disabled={props.disabled}
						placeholder={props.placeholder}
						value={inputValue}
						maxLength="15"
						onChange={async (e) => handlePhoneChange(e)}
					/>
				) : ("")}


					{props.type?.toLowerCase() === "number" ? (
						<input type={props.type} className={className} disabled={props.disabled} maxLength={props.maxLength} value={inputValue} id={props.id} onChange={handleNumber} placeholder={props.placeholder}  />
					) : ("")}



			</>)}

		</div>
	);
}

export default InputComponent;






